module.exports = __webpack_public_path__ + "media/images/communities/samsung_dark-db741b70ec7ad0a9234028b5f5091990.png";